import type { ReactNode } from 'react';
import { Heading } from '../atoms/Heading';
import { Text } from '../atoms/Text';
import styles from './CardHeader.module.css';

export interface CardHeaderProps {
  title: ReactNode;
  /** Id of the heading, e.g. for `aria-labelledby` on the card. */
  id?: string;
  level?: 2 | 3 | 4;
  /** One short sentence, only when it helps a decision (docs/ux-richtlinien.md §1.3). */
  description?: ReactNode;
  /** Compact actions on the right, e.g. a plain "Alle anzeigen" or `…` menu. */
  actions?: ReactNode;
}

/** Title row of a card or section. */
export function CardHeader({ title, id, level = 2, description, actions }: CardHeaderProps) {
  return (
    <div className={styles.header}>
      <div className={styles.text}>
        <Heading level={level} size={level === 2 ? 'lg' : 'md'} id={id}>
          {title}
        </Heading>
        {description && (
          <Text size="sm" tone="muted">
            {description}
          </Text>
        )}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
